import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "코드 생성",
  "description": "Turborepo를 사용하여 코드를 생성하는 방법을 알아봅니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "모노레포를 패키지로 분할하는 것은 코드를 구조화하고, 작업 속도를 높이며, 로컬 개발 경험을 개선하는 훌륭한 방법입니다. Turborepo의 코드 생성 기능을 사용하면 패키지, 모듈, 심지어 개별 UI 컴포넌트를 위한 새로운 소스 코드를 리포지토리의 나머지 부분과 통합되는 구조화된 방식으로 쉽게 생성할 수 있습니다."
  }, {
    "heading": "빈-패키지-추가",
    "content": "모노레포에 새로운 빈 앱 또는 패키지를 추가합니다."
  }, {
    "heading": "빈-패키지-추가",
    "content": "gen workspace의 사용 가능한 모든 옵션을 확인하세요."
  }, {
    "heading": "기존-패키지-복사",
    "content": "기존 워크스페이스를 새 앱 또는 패키지의 템플릿으로 사용할 수 있습니다. 이는 기존 모노레포 내의 워크스페이스와 다른 리포지토리의 원격 워크스페이스(GitHub URL을 통해 지정) 모두에서 작동합니다."
  }, {
    "heading": "예제",
    "content": "리포지토리의 기존 패키지에서 복사하여 모노레포에 새 패키지를 생성합니다."
  }, {
    "heading": "예제",
    "content": "원격 패키지에서 복사하여 모노레포에 새 워크스페이스를 생성합니다."
  }, {
    "heading": "예제",
    "content": "참고: 원격 소스에서 추가할 때 Turborepo는 리포지토리에 필요한 모든 종속성이 있고 올바른 패키지 매니저를 사용하고 있는지 확인할 수 없습니다. 이 경우 새 워크스페이스가 리포지토리 내에서 예상대로 작동하도록 일부 수동 수정이 필요할 수 있습니다."
  }, {
    "heading": "예제",
    "content": "gen workspace --copy의 사용 가능한 모든 옵션을 확인하세요."
  }, {
    "heading": "커스텀-생성기",
    "content": "내장 생성기가 요구 사항에 맞지 않는 경우 Plop 설정을 사용하여 자체 커스텀 생성기를 만들 수 있습니다.\nTurborepo는 리포지토리 내의 모든 생성기 설정을 자동으로 감지하고 명령줄에서 실행할 수 있도록 합니다."
  }, {
    "heading": "커스텀-생성기",
    "content": "Turborepo Generators는 Plop 위에 구축되어 있지만 리포지토리에 plop을\n종속성으로 설치할 필요가 없습니다."
  }, {
    "heading": "커스텀-생성기",
    "content": "Turborepo는 모든 Plop 설정 옵션과 기능을 이해하지만, Turborepo로 구성된 리포지토리 내에서 생성기를 작성하는 경험을 개선하기 위한 몇 가지 추가 기능을 제공합니다."
  }, {
    "heading": "커스텀-생성기",
    "content": "생성기는 워크스페이스별로 자동으로 검색, 로드 및 구성됩니다(단일 설정 파일 내에서 수동으로 load할 필요 없음)"
  }, {
    "heading": "커스텀-생성기",
    "content": "생성기는 정의된 워크스페이스의 루트에서 자동으로 실행됩니다"
  }, {
    "heading": "커스텀-생성기",
    "content": "생성기는 리포지토리 내 어디서나 호출할 수 있습니다(또는 --root 플래그를 통해 외부에서도 가능)"
  }, {
    "heading": "커스텀-생성기",
    "content": "TypeScript 생성기는 별도의 설정 없이 지원됩니다"
  }, {
    "heading": "커스텀-생성기",
    "content": "plop은 리포지토리의 종속성으로 설치할 필요가 없습니다"
  }, {
    "heading": "커스텀-생성기",
    "content": "ESM 종속성은 현재 커스텀 생성기 내에서 지원되지 않습니다."
  }, {
    "heading": "시작하기",
    "content": "커스텀 생성기를 빌드하고 실행하려면 Turborepo를 사용하는 모노레포 내 어디서나 다음 명령을 실행하세요."
  }, {
    "heading": "시작하기",
    "content": "기존 생성기를 선택하거나 아직 없는 경우 생성하라는 메시지가 표시됩니다. 리포지토리의 루트에 있는 turbo/generators/config.ts(또는 config.js) 또는 임의의 워크스페이스 내에서 수동으로 설정을 생성할 수도 있습니다."
  }, {
    "heading": "시작하기",
    "content": "TypeScript를 사용하는 경우 필요한 TS 타입에 액세스하려면 the @turbo/gen\npackage를\ndevDependency로 설치해야 합니다."
  }, {
    "heading": "시작하기",
    "content": "예를 들어, 다음은 생성기를 위한 세 가지 위치가 있는 모노레포를 보여줍니다:"
  }, {
    "heading": "시작하기",
    "content": "워크스페이스 내에서 생성된 생성기는 리포지토리 루트나 생성기 설정 위치가 아닌 워크스페이스 루트에서 자동으로 실행됩니다."
  }, {
    "heading": "시작하기",
    "content": "이를 통해 생성기를 더 간단하게 작성할 수 있습니다. [workspace-root]에 파일을 생성할 때 ../../<file>이 아닌 <file>로만 지정하면 됩니다."
  }, {
    "heading": "시작하기",
    "content": "Plop을 사용한 커스텀 생성기 생성에 대해 자세히 알아보세요."
  }, {
    "heading": "생성기-작성",
    "content": "생성기 설정 파일은 Plop 설정 객체를 반환하는 함수입니다. 설정 객체는\n생성기의 프롬프트와 작업을 정의하는 데 사용됩니다."
  }, {
    "heading": "생성기-작성",
    "content": "가장 간단한 형태의 생성기 설정 파일은 다음과 같습니다:"
  }, {
    "heading": "프롬프트",
    "content": "프롬프트는 Plop prompts를 사용하여 작성되며 사용자로부터 정보를 수집하는 데 사용됩니다."
  }, {
    "heading": "작업",
    "content": "작업은 내장 Plop 작업 또는 직접 정의한 커스텀 작업 함수를 사용할 수 있습니다:"
  }, {
    "heading": "생성기-실행",
    "content": "생성기 설정 파일을 만든 후에는 선택 프롬프트를 건너뛰고 지정된 생성기를 직접 실행할 수 있습니다:"
  }, {
    "heading": "생성기-실행",
    "content": "--args를 사용하여 생성기 프롬프트에 인수를 직접 전달할 수도 있습니다:"
  }, {
    "heading": "생성기-실행",
    "content": "자세한 내용은 Plop 문서의 프롬프트 우회를 참조하세요."
  }, {
    "heading": "생성기-실행",
    "content": "gen의 사용 가능한 모든 옵션을 확인하세요."
  }],
  "headings": [{
    "id": "빈-패키지-추가",
    "content": "빈 패키지 추가"
  }, {
    "id": "기존-패키지-복사",
    "content": "기존 패키지 복사"
  }, {
    "id": "예제",
    "content": "예제"
  }, {
    "id": "커스텀-생성기",
    "content": "커스텀 생성기"
  }, {
    "id": "시작하기",
    "content": "시작하기"
  }, {
    "id": "생성기-작성",
    "content": "생성기 작성"
  }, {
    "id": "프롬프트",
    "content": "프롬프트"
  }, {
    "id": "작업",
    "content": "작업"
  }, {
    "id": "생성기-실행",
    "content": "생성기 실행"
  }]
};
import {Callout} from '#components/callout';
import {File, Folder, Files} from '#components/files';
import {PackageManagerTabs, Tab} from '#components/tabs';
export const toc = [{
  depth: 2,
  url: "#빈-패키지-추가",
  title: _jsx(_Fragment, {
    children: "빈 패키지 추가"
  })
}, {
  depth: 2,
  url: "#기존-패키지-복사",
  title: _jsx(_Fragment, {
    children: "기존 패키지 복사"
  })
}, {
  depth: 3,
  url: "#예제",
  title: _jsx(_Fragment, {
    children: "예제"
  })
}, {
  depth: 2,
  url: "#커스텀-생성기",
  title: _jsx(_Fragment, {
    children: "커스텀 생성기"
  })
}, {
  depth: 3,
  url: "#시작하기",
  title: _jsx(_Fragment, {
    children: "시작하기"
  })
}, {
  depth: 3,
  url: "#생성기-작성",
  title: _jsx(_Fragment, {
    children: "생성기 작성"
  })
}, {
  depth: 4,
  url: "#프롬프트",
  title: _jsx(_Fragment, {
    children: "프롬프트"
  })
}, {
  depth: 4,
  url: "#작업",
  title: _jsx(_Fragment, {
    children: "작업"
  })
}, {
  depth: 3,
  url: "#생성기-실행",
  title: _jsx(_Fragment, {
    children: "생성기 실행"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "모노레포를 패키지로 분할하는 것은 코드를 구조화하고, 작업 속도를 높이며, 로컬 개발 경험을 개선하는 훌륭한 방법입니다. Turborepo의 코드 생성 기능을 사용하면 패키지, 모듈, 심지어 개별 UI 컴포넌트를 위한 새로운 소스 코드를 리포지토리의 나머지 부분과 통합되는 구조화된 방식으로 쉽게 생성할 수 있습니다."
    }), "\n", _jsx(_components.h2, {
      id: "빈-패키지-추가",
      children: "빈 패키지 추가"
    }), "\n", _jsx(_components.p, {
      children: "모노레포에 새로운 빈 앱 또는 패키지를 추가합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " gen"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " workspace"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "gen workspace"
      }), "의 사용 가능한 모든 ", _jsx(_components.a, {
        href: "/docs/reference/generate#workspace",
        children: "옵션"
      }), "을 확인하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "기존-패키지-복사",
      children: "기존 패키지 복사"
    }), "\n", _jsx(_components.p, {
      children: "기존 워크스페이스를 새 앱 또는 패키지의 템플릿으로 사용할 수 있습니다. 이는 기존 모노레포 내의 워크스페이스와 다른 리포지토리의 원격 워크스페이스(GitHub URL을 통해 지정) 모두에서 작동합니다."
    }), "\n", _jsx(_components.h3, {
      id: "예제",
      children: "예제"
    }), "\n", _jsx(_components.p, {
      children: "리포지토리의 기존 패키지에서 복사하여 모노레포에 새 패키지를 생성합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " gen"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " workspace"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --copy"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "원격 패키지에서 복사하여 모노레포에 새 워크스페이스를 생성합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " gen"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " workspace"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --copy"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " https://github.com/vercel/turborepo/tree/main/examples/with-tailwind/packages/tailwind-config"
            })]
          })
        })
      })
    }), "\n", _jsx(Callout, {
      children: _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "참고"
        }), ": 원격 소스에서 추가할 때 Turborepo는 리포지토리에 필요한 모든 종속성이 있고 올바른 패키지 매니저를 사용하고 있는지 확인할 수 없습니다. 이 경우 새 워크스페이스가 리포지토리 내에서 예상대로 작동하도록 일부 수동 수정이 필요할 수 있습니다."]
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "gen workspace --copy"
      }), "의 사용 가능한 모든 ", _jsx(_components.a, {
        href: "/docs/reference/generate#workspace",
        children: "옵션"
      }), "을 확인하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "커스텀-생성기",
      children: "커스텀 생성기"
    }), "\n", _jsxs(_components.p, {
      children: ["내장 생성기가 요구 사항에 맞지 않는 경우 ", _jsx(_components.a, {
        href: "https://plopjs.com/",
        children: "Plop"
      }), " 설정을 사용하여 자체 커스텀 생성기를 만들 수 있습니다.\nTurborepo는 리포지토리 내의 모든 생성기 설정을 자동으로 감지하고 명령줄에서 실행할 수 있도록 합니다."]
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsxs(_components.p, {
        children: ["Turborepo Generators는 Plop 위에 구축되어 있지만 리포지토리에 ", _jsx(_components.code, {
          children: "plop"
        }), "을\n종속성으로 설치할 필요가 없습니다."]
      })
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 모든 Plop 설정 옵션과 기능을 이해하지만, Turborepo로 구성된 리포지토리 내에서 생성기를 작성하는 경험을 개선하기 위한 몇 가지 추가 기능을 제공합니다."
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["생성기는 워크스페이스별로 자동으로 검색, 로드 및 구성됩니다(단일 설정 파일 내에서 수동으로 ", _jsx(_components.code, {
          children: "load"
        }), "할 필요 없음)"]
      }), "\n", _jsx(_components.li, {
        children: "생성기는 정의된 워크스페이스의 루트에서 자동으로 실행됩니다"
      }), "\n", _jsxs(_components.li, {
        children: ["생성기는 리포지토리 내 어디서나 호출할 수 있습니다(또는 ", _jsx(_components.a, {
          href: "/docs/reference/generate#--root-path",
          children: _jsx(_components.code, {
            children: "--root"
          })
        }), " 플래그를 통해 외부에서도 가능)"]
      }), "\n", _jsx(_components.li, {
        children: "TypeScript 생성기는 별도의 설정 없이 지원됩니다"
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "plop"
        }), "은 리포지토리의 종속성으로 설치할 필요가 없습니다"]
      }), "\n"]
    }), "\n", _jsx(Callout, {
      type: "info",
      title: "알려진 문제",
      children: _jsx(_components.p, {
        children: "ESM 종속성은 현재 커스텀 생성기 내에서 지원되지 않습니다."
      })
    }), "\n", _jsx(_components.h3, {
      id: "시작하기",
      children: "시작하기"
    }), "\n", _jsx(_components.p, {
      children: "커스텀 생성기를 빌드하고 실행하려면 Turborepo를 사용하는 모노레포 내 어디서나 다음 명령을 실행하세요."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " gen"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기존 생성기를 선택하거나 아직 없는 경우 생성하라는 메시지가 표시됩니다. 리포지토리의 루트에 있는 ", _jsx(_components.code, {
        children: "turbo/generators/config.ts"
      }), "(또는 ", _jsx(_components.code, {
        children: "config.js"
      }), ") 또는 ", _jsx(_components.em, {
        children: "임의의"
      }), " 워크스페이스 내에서 수동으로 설정을 생성할 수도 있습니다."]
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsxs(_components.p, {
        children: ["TypeScript를 사용하는 경우 필요한 TS 타입에 액세스하려면 ", _jsxs(_components.a, {
          href: "https://github.com/vercel/turborepo/tree/main/packages/turbo-gen",
          children: ["the ", _jsx(_components.code, {
            children: "@turbo/gen"
          }), "\npackage"]
        }), "를\n", _jsx(_components.code, {
          children: "devDependency"
        }), "로 설치해야 합니다."]
      })
    }), "\n", _jsx(_components.p, {
      children: "예를 들어, 다음은 생성기를 위한 세 가지 위치가 있는 모노레포를 보여줍니다:"
    }), "\n", _jsxs(PackageManagerTabs, {
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsxs(Files, {
          children: [_jsxs(Folder, {
            name: "apps",
            defaultOpen: true,
            children: [_jsx(Folder, {
              name: "docs",
              children: _jsx(File, {
                name: "package.json"
              })
            }), _jsxs(Folder, {
              name: "web",
              defaultOpen: true,
              children: [_jsx(File, {
                name: "package.json"
              }), _jsx(Folder, {
                name: "turbo",
                green: true,
                defaultOpen: true,
                children: _jsxs(Folder, {
                  name: "generators",
                  children: [_jsx(File, {
                    name: "config.ts"
                  }), _jsx(File, {
                    name: "templates"
                  })]
                })
              })]
            })]
          }), _jsx(Folder, {
            name: "packages",
            defaultOpen: true,
            children: _jsxs(Folder, {
              name: "ui",
              defaultOpen: true,
              children: [_jsx(File, {
                name: "package.json"
              }), _jsx(Folder, {
                name: "turbo",
                green: true,
                defaultOpen: true,
                children: _jsxs(Folder, {
                  name: "generators",
                  children: [_jsx(File, {
                    name: "config.ts"
                  }), _jsx(File, {
                    name: "templates"
                  })]
                })
              })]
            })
          }), _jsx(Folder, {
            name: "turbo",
            green: true,
            defaultOpen: true,
            children: _jsxs(Folder, {
              name: "generators",
              children: [_jsx(File, {
                name: "config.ts"
              }), _jsx(File, {
                name: "templates"
              })]
            })
          }), _jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "package-lock.yaml"
          }), _jsx(File, {
            name: "pnpm-workspace.yaml"
          }), _jsx(File, {
            name: "turbo.json"
          })]
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsxs(Files, {
          children: [_jsxs(Folder, {
            name: "apps",
            defaultOpen: true,
            children: [_jsx(Folder, {
              name: "docs",
              children: _jsx(File, {
                name: "package.json"
              })
            }), _jsxs(Folder, {
              name: "web",
              defaultOpen: true,
              children: [_jsx(File, {
                name: "package.json"
              }), _jsx(Folder, {
                name: "turbo",
                green: true,
                defaultOpen: true,
                children: _jsxs(Folder, {
                  name: "generators",
                  children: [_jsx(File, {
                    name: "config.ts"
                  }), _jsx(File, {
                    name: "templates"
                  })]
                })
              })]
            })]
          }), _jsx(Folder, {
            name: "packages",
            defaultOpen: true,
            children: _jsxs(Folder, {
              name: "ui",
              defaultOpen: true,
              children: [_jsx(File, {
                name: "package.json"
              }), _jsx(Folder, {
                name: "turbo",
                green: true,
                defaultOpen: true,
                children: _jsxs(Folder, {
                  name: "generators",
                  children: [_jsx(File, {
                    name: "config.ts"
                  }), _jsx(File, {
                    name: "templates"
                  })]
                })
              })]
            })
          }), _jsx(Folder, {
            name: "turbo",
            green: true,
            defaultOpen: true,
            children: _jsxs(Folder, {
              name: "generators",
              children: [_jsx(File, {
                name: "config.ts"
              }), _jsx(File, {
                name: "templates"
              })]
            })
          }), _jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "yarn.lock"
          }), _jsx(File, {
            name: "turbo.json"
          })]
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsxs(Files, {
          children: [_jsxs(Folder, {
            name: "apps",
            defaultOpen: true,
            children: [_jsx(Folder, {
              name: "docs",
              children: _jsx(File, {
                name: "package.json"
              })
            }), _jsxs(Folder, {
              name: "web",
              defaultOpen: true,
              children: [_jsx(File, {
                name: "package.json"
              }), _jsx(Folder, {
                name: "turbo",
                green: true,
                defaultOpen: true,
                children: _jsxs(Folder, {
                  name: "generators",
                  children: [_jsx(File, {
                    name: "config.ts"
                  }), _jsx(File, {
                    name: "templates"
                  })]
                })
              })]
            })]
          }), _jsx(Folder, {
            name: "packages",
            defaultOpen: true,
            children: _jsxs(Folder, {
              name: "ui",
              defaultOpen: true,
              children: [_jsx(File, {
                name: "package.json"
              }), _jsx(Folder, {
                name: "turbo",
                green: true,
                defaultOpen: true,
                children: _jsxs(Folder, {
                  name: "generators",
                  children: [_jsx(File, {
                    name: "config.ts"
                  }), _jsx(File, {
                    name: "templates"
                  })]
                })
              })]
            })
          }), _jsx(Folder, {
            name: "turbo",
            green: true,
            defaultOpen: true,
            children: _jsxs(Folder, {
              name: "generators",
              children: [_jsx(File, {
                name: "config.ts"
              }), _jsx(File, {
                name: "templates"
              })]
            })
          }), _jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "package-lock.json"
          }), _jsx(File, {
            name: "turbo.json"
          })]
        })
      }), _jsx(Tab, {
        value: "bun (Beta)",
        children: _jsxs(Files, {
          children: [_jsxs(Folder, {
            name: "apps",
            defaultOpen: true,
            children: [_jsx(Folder, {
              name: "docs",
              children: _jsx(File, {
                name: "package.json"
              })
            }), _jsxs(Folder, {
              name: "web",
              defaultOpen: true,
              children: [_jsx(File, {
                name: "package.json"
              }), _jsx(Folder, {
                name: "turbo",
                green: true,
                defaultOpen: true,
                children: _jsxs(Folder, {
                  name: "generators",
                  children: [_jsx(File, {
                    name: "config.ts"
                  }), _jsx(File, {
                    name: "templates"
                  })]
                })
              })]
            })]
          }), _jsx(Folder, {
            name: "packages",
            defaultOpen: true,
            children: _jsxs(Folder, {
              name: "ui",
              defaultOpen: true,
              children: [_jsx(File, {
                name: "package.json"
              }), _jsx(Folder, {
                name: "turbo",
                green: true,
                defaultOpen: true,
                children: _jsxs(Folder, {
                  name: "generators",
                  children: [_jsx(File, {
                    name: "config.ts"
                  }), _jsx(File, {
                    name: "templates"
                  })]
                })
              })]
            })
          }), _jsx(Folder, {
            name: "turbo",
            green: true,
            defaultOpen: true,
            children: _jsxs(Folder, {
              name: "generators",
              children: [_jsx(File, {
                name: "config.ts"
              }), _jsx(File, {
                name: "templates"
              })]
            })
          }), _jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "bun.lock"
          }), _jsx(File, {
            name: "turbo.json"
          })]
        })
      })]
    }), "\n", _jsx(_components.p, {
      children: "워크스페이스 내에서 생성된 생성기는 리포지토리 루트나 생성기 설정 위치가 아닌 워크스페이스 루트에서 자동으로 실행됩니다."
    }), "\n", _jsxs(_components.p, {
      children: ["이를 통해 생성기를 더 간단하게 작성할 수 있습니다. ", _jsx(_components.code, {
        children: "[workspace-root]"
      }), "에 파일을 생성할 때 ", _jsx(_components.code, {
        children: "../../<file>"
      }), "이 아닌 ", _jsx(_components.code, {
        children: "<file>"
      }), "로만 지정하면 됩니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://plopjs.com/documentation/#creating-a-generator",
        children: "Plop을 사용한 커스텀 생성기 생성"
      }), "에 대해 자세히 알아보세요."]
    }), "\n", _jsx(_components.h3, {
      id: "생성기-작성",
      children: "생성기 작성"
    }), "\n", _jsxs(_components.p, {
      children: ["생성기 설정 파일은 ", _jsx(_components.a, {
        href: "https://plopjs.com/",
        children: "Plop"
      }), " 설정 객체를 반환하는 함수입니다. 설정 객체는\n생성기의 프롬프트와 작업을 정의하는 데 사용됩니다."]
    }), "\n", _jsx(_components.p, {
      children: "가장 간단한 형태의 생성기 설정 파일은 다음과 같습니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo/generators/config.ts",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "import"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " type"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { PlopTypes } "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "from"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"@turbo/gen\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ";"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "export"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " default"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " function"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " generator"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "(plop"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " PlopTypes"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "."
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "NodePlopAPI"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ")"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " void"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // create a generator"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "  plop"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: ".setGenerator"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "("
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"Generator name\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    description"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"Generator description\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "    // gather information from the user"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    prompts"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      ..."
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    ]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "    // perform actions based on the prompts"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    actions"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      ..."
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    ]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  });"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h4, {
      id: "프롬프트",
      children: "프롬프트"
    }), "\n", _jsxs(_components.p, {
      children: ["프롬프트는 ", _jsx(_components.a, {
        href: "https://plopjs.com/documentation/#using-prompts",
        children: "Plop prompts"
      }), "를 사용하여 작성되며 사용자로부터 정보를 수집하는 데 사용됩니다."]
    }), "\n", _jsx(_components.h4, {
      id: "작업",
      children: "작업"
    }), "\n", _jsxs(_components.p, {
      children: ["작업은 ", _jsx(_components.a, {
        href: "https://plopjs.com/documentation/#built-in-actions",
        children: "내장 Plop 작업"
      }), " 또는 직접 정의한 ", _jsx(_components.a, {
        href: "https://plopjs.com/documentation/#functionsignature-custom-action",
        children: "커스텀 작업 함수"
      }), "를 사용할 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo/generators/config.ts",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "import"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " type"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { PlopTypes } "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "from"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"@turbo/gen\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ";"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "const"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " customAction"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " PlopTypes"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "."
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "CustomActionFunction"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " ="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " async"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " (answers) "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "=>"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // fetch data from a remote API"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  const"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " results"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " ="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " await"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " fetchRemoteData"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "();"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // add the response to the answers, making this data available to actions"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "  answers"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ".results "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " results;"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // return a status string"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  return"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " 'Finished data fetching!'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ";"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "export"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " default"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " function"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " generator"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "(plop"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " PlopTypes"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "."
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "NodePlopAPI"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ")"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " void"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // create a generator"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "  plop"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: ".setGenerator"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "("
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"Generator name\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    description"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"Generator description\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    prompts"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      ..."
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    ]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    actions"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      customAction"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      {"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "/* actions now have access to `answers.results` */"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      ..."
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    ]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  });"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "생성기-실행",
      children: "생성기 실행"
    }), "\n", _jsx(_components.p, {
      children: "생성기 설정 파일을 만든 후에는 선택 프롬프트를 건너뛰고 지정된 생성기를 직접 실행할 수 있습니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " gen"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [generator-name]"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "--args"
      }), "를 사용하여 생성기 프롬프트에 인수를 직접 전달할 수도 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " gen"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [generator-name] --args answer1 answer2 ..."
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 내용은 Plop 문서의 ", _jsx(_components.a, {
        href: "https://plopjs.com/documentation/#bypassing-prompts",
        children: "프롬프트 우회"
      }), "를 참조하세요."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "gen"
      }), "의 사용 가능한 모든 ", _jsx(_components.a, {
        href: "/docs/reference/generate#run-generator-name",
        children: "옵션"
      }), "을 확인하세요."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
